export const SINGLE_NAME_FIELD = "singleNameField";
export const ALL_FIELDS = "allFields";
